// extracted by mini-css-extract-plugin
export var boxItems = "_6j-1";
export var boxItemsLg = "_6j-2";
export var button = "_6j-7";
export var buttonHoverless = "_6j-9";
export var buttonLg = "_6j-8";
export var filterGroupBox = "_6j-0";
export var icon = "_6j-3";
export var iconSecondary = "_6j-6";
export var iconWrapper = "_6j-4";
export var iconWrapperLg = "_6j-5";
export var truncatedLabel = "_6j-a";